import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router'
import ConfirmDialog from './ConfirmDialog'

type Props = {
  open: boolean
  onClose: ()=> void
}
const ConfirmLoginDialog: React.FC<Props> = ({open, onClose}) => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  return <ConfirmDialog
    open={open}
    onClose={onClose}
    message={t('modal.login_confirm')}
    ok_text={t('help.go')}
    ok_color='primary'
    cancel_text={t('general.cancel')}
    action={()=> {
      const search_params = new URLSearchParams({
        from: location.pathname + location.search
      })
      navigate(`/login?${search_params}`)
    }}
  />
}
export default ConfirmLoginDialog